export const buildProvenance = { "commitHash": "dc2850ed85cddec3edbbf572f76507609c1f0aa2", "branchName": "refs/heads/release/2024.2", "buildDate": "2024-08-31T16:38:03.427Z", "version": "2024.2.9427" };
